import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";

function Eexpenses() {
  const [data, setData] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

//   const user = JSON.parse(localStorage.getItem("userData"));


  const fetchEexpenses = useCallback(async () => {
  try {
    const response = await axiosInstance.get("api/employee-expenses-approval-data");
    const allData = response.data || [];
      setData(allData);
  } catch (error) {
    console.error("Error fetching Red Process data:", error);
  }
}, []);


  useEffect(() => {
    fetchEexpenses();
  }, [fetchEexpenses]);


// Custom cell component for Description with expand/collapse functionality
const DescriptionCell = ({ description }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => setExpanded(!expanded);

  const truncated = description?.length > 40 ? description.slice(0, 40) + "..." : description;

  return (
    <div style={{ maxWidth: 300 }}>
      <div>{expanded ? description : truncated}</div>
      {description?.length > 40 && (
        <button
          onClick={toggleExpand}
          style={{
            background: "none",
            color: "blue",
            border: "none",
            padding: 0,
            cursor: "pointer",
            fontSize: "0.85rem"
          }}
        >
          {expanded ? "View Less" : "View More"}
        </button>
      )}
    </div>
  );
};
  // Columns for DataTable
  const columns = [
    {
      name: "Employee Name",width:"150px",
      selector: (row) => row.employee_name,
      sortable: true,
    },
    {
      name: "Date", 
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "Department",
      selector: (row) => row.department,
      sortable: true,
    },
 {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
    },
    {
    name: "Description",
    selector: (row) => row.description,
    cell: (row) => <DescriptionCell description={row.description} />,
    sortable: false,
    grow: 2, // makes the column wider
    },

    {
      name: "ApprovalDate",width:"150px",
      selector: (row) => row.approvalDate,
      sortable: true,
    },
    {
      name: "Payment Done",
      selector: (row) => row.payment_done || "N/A",
      sortable: true,
    },
      {
      name: "Budget Head",
      selector: (row) => row.budget_head || "N/A",
      sortable: true,
    },
    // {
    //   name: "Result",
    //   selector: (row) => (
    //     <span
    //       style={{
    //         color:
    //           row.Result === "Red"
    //             ? "red"
    //             : row.Result === "Orange"
    //             ? "orange"
    //             : "inherit",
    //         fontWeight: "bold",
    //       }}
    //     >
    //       {row.Result}
    //     </span>
    //   ),
    //   sortable: true,
    // },

  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
          <div className="container mt-0">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="mb-5">Approved Expenses </h3>
            </div>
            <DataTable
              columns={columns}
              data={data}
              pagination
              highlightOnHover
              striped
              persistTableHead
            />
          </div>
        </main>
      </div>
    </div>
  );
}

export default Eexpenses;
